import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const SectionQuicklinks = () => {
  // Daftar ikon dengan URL yang diberikan
  const quicklinks = [
    {
      to: "#",
      icon: "https://res.cloudinary.com/utmb-world/image/upload/c_limit,h_127/c_limit,h_127/v1720407606/kosciuszko/Social%20Icons/Checkpoint_7d56214caa.png",
      label: "Runner Guide",
    },
    {
      to: "#",
      icon: "https://res.cloudinary.com/utmb-world/image/upload/c_limit,h_127/c_limit,h_127/v1720407607/kosciuszko/Social%20Icons/Dropbags_b261ecdfdf.png",
      label: "Drop Bags",
    },
    {
      to: "#",
      icon: "https://res.cloudinary.com/utmb-world/image/upload/c_limit,h_127/c_limit,h_127/v1720407607/kosciuszko/Social%20Icons/Supporters_6d3f73614a.png",
      label: "Support Crew",
    },
    {
      to: "#",
      icon: "https://res.cloudinary.com/utmb-world/image/upload/c_limit,h_127/c_limit,h_127/v1720407607/kosciuszko/Social%20Icons/Shuttle_bus_b6503870ca.png",
      label: "Shuttle Buses",
    },
    {
      to: "#",
      icon: "https://res.cloudinary.com/utmb-world/image/upload/c_limit,h_127/c_limit,h_127/v1720407607/kosciuszko/Social%20Icons/Race_bib_36239db899.png",
      label: "Check-In",
    },
    {
      to: "#",
      icon: "https://res.cloudinary.com/utmb-world/image/upload/v1720407607/kosciuszko/Social%20Icons/Mandatory_gear_8ed1a317d3.png",
      label: "Mandatory Gear",
    },
  ];

  // Animasi untuk setiap ikon
  const iconVariants = {
    hidden: { opacity: 0, scale: 0.8, y: 20 },
    visible: (i) => ({
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        delay: i * 0.2, // Delay bertahap untuk setiap ikon
        duration: 0.5,
        ease: "easeInOut",
      },
    }),
  };

  return (
    <motion.div
      className="py-8 text-center"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.8, ease: "easeInOut" }}
      viewport={{ once: true }}
    >
      <div className="grid grid-cols-2 md:grid-cols-3 gap-6 justify-items-center">
        {quicklinks.map((link, index) => (
          <motion.div
            key={index}
            custom={index}
            initial="hidden"
            whileInView="visible"
            variants={iconVariants}
            viewport={{ once: true }}
          >
            <Link to={link.to} className="text-cyan-600 hover:text-cyan-800 flex flex-col items-center">
              <img
                src={link.icon}
                alt={link.label}
                className="w-16 h-16 mb-2 object-contain"
              />
              <span>{link.label}</span>
            </Link>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};